var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBookmark = function SvgIconBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 11.483 5 9.933l3.666 1.55V1.916H1.333v9.567Zm-.3 1.216a.457.457 0 0 1-.475-.033.474.474 0 0 1-.225-.417V1.916c0-.267.1-.5.3-.7.2-.2.433-.3.7-.3h7.333c.267 0 .5.1.7.3.2.2.3.433.3.7v10.333a.474.474 0 0 1-.225.417.457.457 0 0 1-.475.033L5 11l-3.967 1.7Zm.3-10.783h7.333-7.333Z",
    fill: "#4F52C3"
  })));
};
export default SvgIconBookmark;